import { CatHeading } from '@blocks-react/components/Heading';
import { CustomerAccountNoActiveEquipmentDescriptionProps } from '../../types';

export const CustomerAccountNoActiveEquipmentDescription = ({
  children
}: CustomerAccountNoActiveEquipmentDescriptionProps) => {
  return <CatHeading variant="body-sm">{children}</CatHeading>;
};
